module.exports = __webpack_public_path__ + "static/media/img_card_2.8bead405.svg";